import React from "react";
import { Nav, Sidenav, Dropdown, Icon } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faKey,
  faRupeeSign,
  faChartLine,
  faFileAlt,
  faShieldAlt,
  faTable,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../SideMenu.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  withRouter,
  useParams,
} from "react-router-dom";
import { getUserType } from "../utils/index";

var revenueReportText = "Revenue Report";
if (getUserType() == "Occupier" || getUserType() == "occupier") {
  revenueReportText = "Expense Report";
}

class DashboardSideMenu extends React.Component {
  state = {
    openMenu: ["1"],
    activeKey: "1-1",
  };
  constructor(props) {
    super(props);
  }
  render() {
    let url = this.props.match;
    console.log(this.props.location.pathname);
    return (
      <div className="leftSidebar">
        <Sidenav
          activeKey={this.state.activeKey}
          openKeys={this.state.openMenu}
          onOpenChange={(openKeys, event) => {
            console.log(openKeys[openKeys.length - 1]);
            this.setState({ openMenu: [openKeys[openKeys.length - 1]] });
          }}
          //defaultOpenKeys={['1', '2']}
        >
          <Sidenav.Body>
            <Nav>
              <Dropdown
                eventKey="1"
                title="Asset"
                icon={<FontAwesomeIcon icon={faTable} />}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}`}
                  onSelect={() => {
                    this.state.activeKey = "1-1";
                  }}
                  eventKey="1-1"
                >
                  Summary
                </Dropdown.Item>
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}`}
                  onSelect={() => {
                    this.state.activeKey = "1-2";
                  }}
                  eventKey="1-2"
                >
                  Asset Analysis
                </Dropdown.Item>
              </Dropdown>

              {/* <Dropdown
                eventKey="2"
                title="Sales"
                icon={<FontAwesomeIcon icon={faChartLine} />}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/lease-report-sales-forecast`}
                  onSelect={() => {
                    this.state.activeKey = "2-1";
                  }}
                  eventKey="2-1"
                >
                  Forecast
                </Dropdown.Item>
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/lease-report-sales-actual`}
                  onSelect={() => {
                    this.state.activeKey = "2-2";
                  }}
                  eventKey="2-2"
                >
                  Actual
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/lease-report-sales-view`}
                  onSelect={() => {
                    this.state.activeKey = "2-3";
                  }}
                  eventKey="2-3"
                >
                  Sales View
                </Dropdown.Item>
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/lease-report-sales-comparison`}
                  onSelect={() => {
                    this.state.activeKey = "6-2";
                  }}
                  eventKey="2-5"
                >
                  Sales Comparison
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/lease-and-sales-portfolio-view`}
                  onSelect={() => {
                    this.state.activeKey = "6-3";
                  }}
                  eventKey="2-5"
                >
                  Sales View - Portfolio
                </Dropdown.Item>
              </Dropdown> */}

              {/* <Dropdown
                eventKey="3"
                componentClass={Link}
                to={`${url.path}/lease-documentation`}
                title={revenueReportText.replace("Report", "")}
                icon={<FontAwesomeIcon icon={faRupeeSign} />}
              >
                <Dropdown.Item
                  onSelect={() => {
                    this.state.activeKey = "3-1";
                  }}
                  onClick={() => {
                    this.state.activeKey = "3";
                    this.props.history.push({
                      pathname: `${url.path}/revenue-report`,
                    });
                  }}
                  eventKey="3-1"
                >
                  {revenueReportText}
                </Dropdown.Item>
                <Dropdown.Item
                  onSelect={() => {
                    this.state.activeKey = "3-2";
                  }}
                  onClick={() => {
                    this.state.activeKey = "3";
                    this.props.history.push({
                      pathname: `${url.path}/lockin-revenue-report`,
                    });
                  }}
                  eventKey="3-1"
                >
                  Lockin {revenueReportText}
                </Dropdown.Item>
                <Dropdown.Item
                  onSelect={() => {
                    this.state.activeKey = "3-3";
                  }}
                  onClick={() => {
                    this.state.activeKey = "3";
                    this.props.history.push({
                      pathname: `${url.path}/escalation-report`,
                    });
                  }}
                  eventKey="3-1"
                >
                  Escalation Report
                </Dropdown.Item>

                <Dropdown.Item
                  onSelect={() => {
                    this.state.activeKey = "3-4";
                  }}
                  onClick={() => {
                    this.state.activeKey = "3";
                    this.props.history.push({
                      pathname: `${url.path}/mg-vs-revenue`,
                    });
                  }}
                  eventKey="3-1"
                >
                  MG Higher than Revenue
                </Dropdown.Item>
              </Dropdown> */}

              {/* <Dropdown
                eventKey="7"
                title="Security Deposit"
                icon={<FontAwesomeIcon icon={faShieldAlt} />}
                onClick={() => {
                  this.state.activeKey = "4";
                }}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/lease-security-deposit`}
                  onSelect={() => {
                    this.state.activeKey = "4-1";
                  }}
                  eventKey="4-1"
                >
                  Security Deposit Milestone
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/input-security-deposit`}
                  onSelect={() => {
                    this.state.activeKey = "4-2";
                  }}
                  eventKey="4-2"
                >
                  Input Security Deposit
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/security-deposit-comparison`}
                  onSelect={() => {
                    this.state.activeKey = "4-3";
                  }}
                  eventKey="4-3"
                >
                  Security Deposit Comparison
                </Dropdown.Item>
              </Dropdown> */}

              {/* <Dropdown
                eventKey="5"
                componentClass={Link}
                to={`${url.path}/lease-documentation`}
                title="Lease Documentation"
                icon={<FontAwesomeIcon icon={faFileAlt} />}
                onClick={() => {
                  this.state.activeKey = "5";
                  this.props.history.push(`${url.path}/lease-documentation`);
                }}
              ></Dropdown> */}

              {/* <Dropdown
                eventKey="6"
                componentClass={Link}
                to={`${url.path}/outflow`}
                title="Outflow"
                icon={<FontAwesomeIcon icon={faFileAlt} />}
                onClick={() => {
                  this.state.activeKey = "6";
                  this.props.history.push(`${url.path}/outflow`);
                }}
              ></Dropdown> */}

              {/* <Dropdown
                eventKey="8"
                title="Asset Report"
                icon={<FontAwesomeIcon icon={faShieldAlt} />}
                onClick={() => {
                  this.state.activeKey = "4";
                }}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/compliance-tracker`}
                  onSelect={() => {
                    this.state.activeKey = "8-1";
                  }}
                  eventKey="8-1"
                >
                  Compliance Report
                </Dropdown.Item>
              </Dropdown> */}

              {/* <Dropdown
                eventKey="9"
                title="Gift Vouchers"
                icon={<FontAwesomeIcon icon={faShieldAlt} />}
                onClick={() => {
                  this.state.activeKey = "4";
                }}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/gift-vouchers-actual`}
                  onSelect={() => {
                    this.state.activeKey = "9-1";
                  }}
                  eventKey="4-2"
                >
                  Actual
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/gift-vouchers-view`}
                  onSelect={() => {
                    this.state.activeKey = "9-2";
                  }}
                  eventKey="4-3"
                >
                  Comparison
                </Dropdown.Item>
              </Dropdown> */}

              {/* <Dropdown
                eventKey="10"
                title="CAM Actualization"
                icon={<FontAwesomeIcon icon={faShieldAlt} />}
                onClick={() => {
                  this.state.activeKey = "10";
                }}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/cam-actualization-actual`}
                  onSelect={() => {
                    this.state.activeKey = "10-1";
                  }}
                  eventKey="10-2"
                >
                  Actual
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/cam-actualization-view`}
                  onSelect={() => {
                    this.state.activeKey = "10-2";
                  }}
                  eventKey="10-2"
                >
                  Comparison
                </Dropdown.Item>
              </Dropdown> */}

              {/* <Dropdown
                eventKey="11"
                title="Close Deals"
                icon={<FontAwesomeIcon icon={faKey} />}
                onClick={() => {
                  this.state.activeKey = "11";
                }}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/acquisition-report`}
                  onSelect={() => {
                    this.state.activeKey = "11-1";
                  }}
                  eventKey="11-1"
                >
                  Acquisition
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/asset-management-report`}
                  onSelect={() => {
                    this.state.activeKey = "11-2";
                  }}
                  eventKey="11-2"
                >
                  Asset Management
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/valuation-report`}
                  onSelect={() => {
                    this.state.activeKey = "11-3";
                  }}
                  eventKey="11-3"
                >
                  Valuation
                </Dropdown.Item>
              </Dropdown> */}
            </Nav>
          </Sidenav.Body>
        </Sidenav>
      </div>
    );
  }
}

export default withRouter(DashboardSideMenu);
